import { supabase } from '@/integrations/supabase/client';
import { ClassifiedError } from './errorTypes';

export const logErrorToAuditLogs = async (
  classifiedError: ClassifiedError,
  context?: {
    action?: string;
    table_name?: string;
    record_id?: string;
    component?: string;
  }
): Promise<void> => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    const logData = {
      action: context?.action || `error_${classifiedError.category}`,
      table_name: context?.table_name || 'system',
      record_id: context?.record_id || null,
      new_values: {
        category: classifiedError.category,
        message: classifiedError.message,
        userMessage: classifiedError.userMessage,
        retryable: classifiedError.retryable,
        code: classifiedError.code,
        field: classifiedError.field,
        component: context?.component,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      }
    };

    await supabase.from('audit_logs').insert(logData);
  } catch (error) {
    // Silently fail logging to avoid error loops
    console.error('Failed to log error to audit_logs:', error);
  }
};

export const logErrorToConsole = (
  classifiedError: ClassifiedError,
  context?: string
): void => {
  const prefix = context ? `[${context}]` : '[Error]';
  console.error(`${prefix} ${classifiedError.category}:`, {
    message: classifiedError.message,
    userMessage: classifiedError.userMessage,
    retryable: classifiedError.retryable,
    code: classifiedError.code,
    field: classifiedError.field,
    originalError: classifiedError.originalError
  });
};
